export interface Article {
  id: string;
  slug: string;
  category: string;
  categoryLabel: string;
  title: string;
  desc: string;
  author: string;
  authorRole: string;
  date: string;
  readTime: number;
  views: string;
  hot: string;
  tags: string[];
  image: string;
  body: string[];
}

export interface TrendItem {
  title: string;
  platform: string;
  level: string;
  count: string;
  tag: string;
}

export interface Faq {
  q: string;
  a: string;
}

/* ---------------- 栏目分类 ---------------- */
export const categories = [
  { key: 'all', label: '全部' },
  { key: 'drama', label: '影视综' },
  { key: 'star', label: '明星动态' },
  { key: 'music', label: '音乐现场' },
  { key: 'social', label: '网络热议' },
  { key: 'game', label: '游戏圈' },
  { key: 'daily', label: '生活百科' },
];

/* ---------------- 今日瓜点热榜 ---------------- */
export const hotTrends: TrendItem[] = [
  { title: '悬疑剧《山海旧事》大结局结局讨论刷屏', platform: '微博', level: '爆', count: '讨论 28.6 万', tag: '影视综' },
  { title: '「电子榨菜」考古：当年下饭神综再次翻红', platform: '抖音', level: '热', count: '播放 1.2 亿', tag: '影视综' },
  { title: '某音乐节开票秒空，二手平台加价引热议', platform: '微博', level: '热', count: '讨论 9.4 万', tag: '音乐现场' },
  { title: '游戏圈年度整活大赛开启，首日万层热帖', platform: '贴吧', level: '沸', count: '回帖 3.8 万', tag: '游戏圈' },
  { title: '「搭子文化」走红，年轻人社交边界成焦点', platform: '抖音', level: '新', count: '播放 6800 万', tag: '网络热议' },
  { title: '县城青年回流潮：留在大城市还是回小城', platform: '贴吧', level: '热', count: '讨论 6.2 万', tag: '网络热议' },
  { title: '新版古装剧预告片质感获赞，妆造引发考古', platform: '微博', level: '新', count: '讨论 4.1 万', tag: '影视综' },
  { title: '户外露营野餐风潮再起，周末攻略分享刷屏', platform: '抖音', level: '热', count: '播放 9500 万', tag: '生活百科' },
];

/* ---------------- 平台热点对比 ---------------- */
export const platformGroups = [
  {
    name: '微博',
    sub: '围观热议广场',
    icon: 'ri-wechat-2-fill',
    color: 'primary',
    items: [
      { title: '今晚开播的古装剧首播讨论', count: '讨论 12.3 万' },
      { title: '「松弛感」为何成为年度关键词', count: '讨论 8.7 万' },
      { title: '新一季选秀导师阵容猜测', count: '讨论 6.9 万' },
      { title: '周末去郊野公园看星空刷屏', count: '讨论 3.4 万' },
    ],
  },
  {
    name: '抖音',
    sub: '短视频热榜',
    icon: 'ri-vidicon-line',
    color: 'accent',
    items: [
      { title: '「三分钟讲清一部剧」盘点爆款', count: '播放 8600 万' },
      { title: '新出的下饭速食评测走红', count: '播放 5300 万' },
      { title: '演唱会抢票攻略合集收藏过万', count: '播放 4100 万' },
      { title: '猫咪摆烂日常逗笑全网', count: '播放 1.1 亿' },
    ],
  },
  {
    name: '贴吧',
    sub: '深度长帖阵地',
    icon: 'ri-chat-smile-3-line',
    color: 'secondary',
    items: [
      { title: '老玩家眼中的经典游戏变迁', count: '回帖 2.1 万' },
      { title: '县城生活成本大公开', count: '回帖 1.6 万' },
      { title: '一个剧粉的十年追剧手记', count: '回帖 9800' },
      { title: '夏天想看的国产悬疑推荐清单', count: '回帖 7200' },
    ],
  },
];

/* ---------------- 围观指南文章 ---------------- */
export const articles: Article[] = [
  {
    id: 'p1',
    slug: 'haishan-finale-discussion',
    category: 'drama',
    categoryLabel: '影视综',
    title: '悬疑剧《山海旧事》大结局：讨论区为何一夜之间刷屏',
    desc: '从埋线伏笔到人物结局，观众为何对大结局意难平？我们拆解了这场全网热议的发酵路径，帮你看懂热搜背后的讨论焦点。',
    author: '瓜瓜队长',
    authorRole: '追剧手记主编',
    date: '2026-09-06',
    readTime: 6,
    views: '12.6 万',
    hot: '今日最热',
    tags: ['悬疑剧', '大结局', '讨论焦点'],
    image: 'https://readdy.ai/api/search-image?query=warm%20cinematic%20editorial%20illustration%20of%20an%20old%20town%20night%20street%20with%20glowing%20neon%20signs%20and%20a%20crowd%20watching%20a%20bright%20screen%2C%20orange%20and%20cream%20color%20palette%2C%20clean%20flat%20vector%20style%2C%20no%20text&width=960&height=640&seq=cover-haishan-x2&orientation=landscape',
    body: [
      '周末晚上八点，《山海旧事》正式收官。还没等片尾字幕走完，关于大结局的讨论就已挤满了各大平台的热榜。有人为角色结局意难平，有人翻出前几集埋下的伏笔对号入座，也有人干脆开启二刷三刷，只为一帧帧找细节。',
      '这部剧能被反复讨论，关键就在于它的“留白”。编剧没有把所有答案都摆在台面上，而是把关键信息藏在镜头语言和配角的对白里。观众一旦拼出自己理解的那版真相，就会忍不住想找人聊上几句，讨论区自然就热闹起来。',
      '从传播路径看，这场热度经历了三个阶段：先是核心剧粉在评论区提出大胆猜测，接着短视频平台出现“三分钟解析结局”的高能剪辑，最后才把话题推上热搜，引来大批路人观众加入围观。',
      '想吃透这种爆款剧的瓜，与其只看热搜结论，不如先去看看讨论量最高的几条争议帖——真正的信息差，往往藏在高赞评论的楼中楼里。看清大家到底在争什么，才是理解整场热议最快的“吃瓜路线”。',
    ],
  },
  {
    id: 'p2',
    slug: 'concert-ticketing-guide',
    category: 'music',
    categoryLabel: '音乐现场',
    title: '演唱会抢票复盘：三个平台的票务规则差异与避坑清单',
    desc: '开票秒空、加价票、退票规则……把抢票前后容易踩的坑一次说清，让下一位“抢票人”少走弯路。',
    author: '瓜田老手',
    authorRole: '演出观察员',
    date: '2026-09-04',
    readTime: 8,
    views: '8.4 万',
    hot: '热',
    tags: ['演唱会', '抢票', '避坑'],
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20concert%20stage%20with%20a%20crowd%20holding%20up%20tickets%20under%20warm%20amber%20stage%20lights%2C%20orange%20and%20cream%20tones%2C%20clean%20minimal%20vector%2C%20no%20text&width=960&height=640&seq=cover-ticket-x2&orientation=landscape',
    body: [
      '又一场人气演唱会的票在开售瞬间被“秒空”。票务市场的热度肉眼可见，可越是这个时候，越要冷静下来把规则看清，别让好不容易的热情被套路。',
      '先看平台差异。官方渠道通常要求实名认证、限购数量也更严格，是相对稳妥的选择；一些票务平台会开放“候补”机制，没抢到的朋友可以排进候补队列，一旦有退票按顺序补上，比四处刷二手要靠谱得多。',
      '再提醒几个高频坑：一是别轻信“内部渠道”“代抢包中”的话术，转账前多留个心眼；二是仔细读退票规则，演出时间变动或自己临时有事，不同平台的处理方式差别很大；三是警惕价格明显虚高的转卖帖，尽量只在有平台担保的渠道成交。',
      '最后是心态。热门演出一票难求是常态，错过这场还可以留意加场、周边城市的场次，保持关注官方公告，别让抢票的焦虑冲昏头脑。理性吃瓜、理性追现场，才是舒服的看演姿势。',
    ],
  },
  {
    id: 'p3',
    slug: 'zhaicai-electronics',
    category: 'drama',
    categoryLabel: '影视综',
    title: '「电子榨菜」时代：下饭综艺是怎么被全网讨论带火的',
    desc: '一句台词、一个名场面就能点燃一整个月的热搜，下饭综艺的走红逻辑到底是什么？我们拆给你看。',
    author: '下饭研究员',
    authorRole: '综艺观察员',
    date: '2026-09-02',
    readTime: 5,
    views: '6.1 万',
    hot: '新',
    tags: ['下饭综艺', '名场面', '电子榨菜'],
    image: 'https://readdy.ai/api/search-image?query=cozy%20flat%20illustration%20of%20a%20snack%20bowl%20and%20a%20television%20screen%20with%20playful%20food%20characters%20sitting%20together%2C%20warm%20cream%20and%20orange%20palette%2C%20kawaii%20editorial%20vector%2C%20no%20text&width=960&height=640&seq=cover-zhaicai-x2&orientation=landscape',
    body: [
      '“吃饭没点下饭综艺，饭都不香了。”这句话正在成为很多年轻人的口头禅。所谓“电子榨菜”，指的是那些轻松、下饭、可以反复观看的综艺或短剧，一集二十分钟，刚好配一顿饭。',
      '这类内容之所以能出圈，靠的往往不是大制作，而是一两个能引发共鸣的名场面。嘉宾随口一句调侃被网友剪成表情包，一段即兴互动被做成“百万文案”，二次创作反过来又给节目带来新一波流量，形成正向循环。',
      '从讨论焦点看，观众爱看的其实是“真实感”。脚本痕迹太重的桥段没人买账，反而是那些自然流露的反应、没有包袱的相处，最能戳中大家。弹幕里刷屏的“名场面预警”，本质上是对这份真实感的认可。',
      '想判断一部综艺会不会火，可以先去看看它的“名场面二创区”——那里聚集着最活跃的粉丝，也是整场话题发酵的起点。跟着这些讨论点去补正片，往往能比别人更快吃到“第一口热瓜”。',
    ],
  },
  {
    id: 'p4',
    slug: 'short-video-viral',
    category: 'social',
    categoryLabel: '网络热议',
    title: '一条冲上热榜的短视频背后：话题到底是怎么发酵出圈的',
    desc: '从发布到刷屏可能只用了几个小时。拆解短视频热点的传播链路，教你判断哪些瓜值得点进去看。',
    author: '热点搬运工',
    authorRole: '网络观察员',
    date: '2026-08-30',
    readTime: 7,
    views: '5.3 万',
    hot: '热',
    tags: ['短视频', '话题发酵', '热榜'],
    image: 'https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20smartphone%20with%20pulsing%20speech%20bubbles%20and%20trend%20arrows%20floating%20upward%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20flat%20vector%2C%20no%20text&width=960&height=640&seq=cover-video-x2&orientation=landscape',
    body: [
      '你有没有过这样的体验：刷到一条视频时它还是几百点赞，一小时后再打开，已经冲上热榜、全网都在讨论。短视频时代的爆款，速度常常快得超乎想象。',
      '通常一条能出圈的视频，会先在小圈子里获得第一波共鸣，比如某个共鸣点、某个笑点被精准击中。随后，带有情绪张力的片段被大量转发，评论区成了新的“二创现场”，讨论反过来又让视频被推荐给更多人。',
      '平台算法偏爱的是“讨论度”。播放量只是起点，评论、转发、合拍这些互动才是把视频推高的燃料。正因如此，视频里真正能打动人、让人想开口的那句话，往往才是引爆整场热度的“引信”。',
      '对只想轻松围观的你来说，判断一条热点值不值得深挖，可以看两点：一是话题有没有持续的新料进来，二是讨论里有没有出现多种不同的声音。有来有回的瓜才越吃越有滋味，只是一阵风的，看看也就过去了。',
    ],
  },
  {
    id: 'p5',
    slug: 'fan-community-signals',
    category: 'star',
    categoryLabel: '明星动态',
    title: '追星圈那些“信号”：粉丝内部消息是怎么一步步流传出来的',
    desc: '路透、预告、应援、控评……想看懂粉丝圈的语言和风向，这份入门科普能帮你快速“接上电”。',
    author: '吃瓜小助理',
    authorRole: '粉圈观察员',
    date: '2026-08-26',
    readTime: 6,
    views: '7.7 万',
    hot: '热',
    tags: ['粉圈', '应援', '吃瓜入门'],
    image: 'https://readdy.ai/api/search-image?query=moody%20flat%20illustration%20of%20fans%20holding%20glowing%20lightsticks%20in%20a%20stadium%20at%20warm%20sunset%2C%20orange%20and%20cream%20editorial%20vector%2C%20no%20real%20faces%2C%20no%20text&width=960&height=640&seq=cover-fan-x2&orientation=landscape',
    body: [
      '很多刚接触追星圈的人，常被各种“黑话”弄得一头雾水：什么叫“路透”“站子”“控评”“应援”？而这些词背后，其实是一整套信息流通的规则。',
      '先说“信号”的来源。粉丝内部的小道消息，通常源自对行程表、社交账号动态的逐字逐句分析，加上工作人员偶尔的“手滑”，再经讨论区层层解读后逐渐成型。真假难辨的信息，往往就藏在“分析帖”和“实锤帖”的措辞差别里。',
      '想看明白风向，重点是分辨信息的“层级”：公开行程和官方预告最可信；站姐路透图属于“看得见但未必说得清”；而纯靠猜的“瓜”，多半要打上问号。真正老练的围观者，不会把每一句爆料都当真，而是先看有没有旁证。',
      '最后想多说一句：吃瓜图个乐，别把传闻当实锤，也别因为别人观点不同就上纲上线。健康的围观心态，比追到任何一条内幕消息都重要。理性追星，快乐加倍。',
    ],
  },
  {
    id: 'p6',
    slug: 'game-community-meme',
    category: 'game',
    categoryLabel: '游戏圈',
    title: '游戏圈年度整活：新游上线首日，玩家社区的万层热帖',
    desc: '一款游戏能火多久，社区讨论的热度是重要风向标。看看新游玩家都在“整活”什么。',
    author: '副本领航员',
    authorRole: '游戏观察员',
    date: '2026-08-20',
    readTime: 5,
    views: '4.9 万',
    hot: '新',
    tags: ['游戏社区', '新游', '整活'],
    image: 'https://readdy.ai/api/search-image?query=playful%20flat%20illustration%20of%20a%20retro%20game%20controller%20with%20confetti%20and%20floating%20chat%20comment%20bubbles%2C%20warm%20green%20and%20orange%20editorial%20vector%2C%20no%20text&width=960&height=640&seq=cover-game-x2&orientation=landscape',
    body: [
      '一款新游正式上线当天，玩家社区往往比游戏本身还要热闹。开服首日，攻略帖、吐槽帖、整活帖同时开张，轻轻松松就能堆出上万层楼。',
      '社区讨论的热度，某种程度上就是游戏生命力的先行指标。开荒期大家热衷于分享“踩坑经验”和“通关技巧”，一周后风向转向“配队思路”与“玩法深挖”，能持续被讨论的游戏，往往也更能留住玩家。',
      '而最能“整活”的，永远是那些敢于玩梗的玩家。角色名被玩出谐音梗、剧情被剪成搞笑二创，看似不正经的玩闹，其实是最真实的用户口碑——毕竟没人会为不好玩的内容付出这么多热情。',
      '对路人玩家来说，判断一款新游要不要入坑，翻一翻开服第一周的热帖就够用了：看大家是骂得多还是笑得多，看看有没有人愿意为它写长攻略。一栋被认真对待的万层楼，胜过任何夸张的宣传文案。',
    ],
  },
];

/* ---------------- 相关推荐（用于详情页） ---------------- */
export function relatedArticles(currentId: string, count = 3): Article[] {
  const pool = articles.filter((a) => a.id !== currentId);
  return pool.slice(0, count);
}

/* ---------------- 常见问题 ---------------- */
export const faqs: Faq[] = [
  {
    q: '「吃瓜路线」到底是什么？',
    a: '吃瓜路线是一个帮你快速跟上微博、抖音、贴吧等平台热门讨论的围观指南站。我们会把当下最热的话题、最值得看的讨论焦点整理成清晰的路线图，让你几分钟就能了解来龙去脉。',
  },
  {
    q: '内容多久更新一次？',
    a: '今日瓜点热榜与平台热点我们会按天整理更新，围绕当下讨论度最高的影视、音乐、游戏、生活类话题持续补充。遇到大热事件时，相关专栏文章也会同步加急上线。',
  },
  {
    q: '围观这些话题需要注册账号吗？',
    a: '不需要。本站所有榜单、指南和科普文章都免费开放，无需注册登录即可阅读。你只要订阅瓜讯，就能在第一时间收到我们整理好的当日热点。',
  },
  {
    q: '你们会搬运或求证每一条消息吗？',
    a: '我们的定位是整理讨论焦点、梳理话题脉络，帮助你理解“大家为什么在聊”，并不会对未经证实的传闻下结论。涉及事实性的内容，建议以官方来源为准。',
  },
  {
    q: '可以投稿或留言提供话题线索吗？',
    a: '当然欢迎。你可以在关于我们页通过联系表单告诉我们你关注的话题，或直接在页脚留下你的建议。好用的话题线索，我们都会认真看。',
  },
  {
    q: '如何第一时间收到更新？',
    a: '在首页底部的订阅框留下你的邮箱，即可订阅每日瓜讯。我们只会定期推送整理好的热点盘点，不会发送广告或打扰性邮件，随时可以退订。',
  },
];

/* ---------------- 用户口碑 ---------------- */
export const testimonials = [
  {
    name: '小满同学',
    tag: '追剧十年的老剧粉',
    text: '以前总是后知后觉地吃瓜，自从关注吃瓜路线，第二天跟同事聊热搜也能接上话了，省了不少到处翻的时间。',
  },
  {
    name: 'Lin 码字中',
    tag: '新媒体小编',
    text: '做选题最怕找不到方向，这里的热点拆解和话题盘点给了我很多灵感，评论区脉络梳理得特别清楚。',
  },
  {
    name: '奶茶不加糖',
    tag: '下班爱看综艺',
    text: '界面很清爽，扫一眼今日热榜就能知道大家今晚都在聊什么。每篇指南都不长，通勤路上刚好读完。',
  },
  {
    name: '老王不熬夜',
    tag: '游戏与生活观察者',
    text: '喜欢这里的客观态度，不会为了流量夸大其词，把来龙去脉讲明白就点到为止，看着舒服。',
  },
];

/* ---------------- 关于 / 品牌 ---------------- */
export const aboutStats = [
  { value: '1200+', label: '话题盘点' },
  { value: '300+', label: '围观指南' },
  { value: '每日', label: '同步更新' },
  { value: '0', label: '夸大营销' },
];

export const brandPrinciples = [
  { title: '先看清再下嘴', desc: '把话题的来龙去脉与各方讨论梳理清楚，帮助你先看明白、再理性参与，而不是被情绪带着走。' },
  { title: '不传未经证实的料', desc: '只整理大家正在聊什么、为什么聊，不对没有实锤的传闻妄下结论，事实请以官方来源为准。' },
  { title: '轻量好读不拖沓', desc: '每一篇指南都尽量控制在几分钟内读完，用清楚的脉络节省你到处翻找的时间。' },
  { title: '观点可以不同，边界要守住', desc: '尊重每一位用户的表达，也希望你在围观时保持边界感，快乐吃瓜、理性发言。' },
];